import { render, staticRenderFns } from "./whStat.vue?vue&type=template&id=ff844ec0&scoped=true&"
import script from "./whStat.vue?vue&type=script&lang=js&"
export * from "./whStat.vue?vue&type=script&lang=js&"
import style0 from "./whStat.vue?vue&type=style&index=0&id=ff844ec0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff844ec0",
  null
  
)

component.options.__file = "whStat.vue"
export default component.exports